const PUBLIC_EXACT_PATHS = new Set([
  '/login',
  '/reset-password',
  '/register',
  '/privacy',
  '/richiesta-proprietari',
  '/guest-checkin',
  '/r',
]);

const PUBLIC_PATH_PREFIXES = [
  '/richiesta-proprietari/',
  '/guest-checkin/',
  '/activate-account/',
  '/owner-portal/',
  '/companyprofile',
  '/v/',
  '/f/',
  '/t/',
  '/preventivo/',
  '/partner/preventivi/',
  '/home-smart',
];

export const isPublicRoute = (pathname = '') => (
  PUBLIC_EXACT_PATHS.has(pathname) || PUBLIC_PATH_PREFIXES.some(prefix => pathname.startsWith(prefix))
);
